import { motion } from "framer-motion";

const STEPS = [
  {
    n: "1",
    title: "Mount it",
    body: "Two screws or the adhesive pad. Ninety seconds, no tools beyond a screwdriver, no electrician.",
    src: "/images/deck.png",
  },
  {
    n: "2",
    title: "Let it charge",
    body: "The top solar panel drinks in 6–8 hours of daylight and stores it in the 600 mAh cell.",
    src: "/images/charge.png",
  },
  {
    n: "3",
    title: "Watch it glow",
    body: "The dusk-to-dawn sensor wakes the warm LED at sunset and lets it run 8–10 hours, all night long.",
    src: "/images/garden.png",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-32 sm:py-40 border-t border-white/10" data-testid="how-it-works-section">
    <div className="max-w-6xl mx-auto px-6 sm:px-10">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-xs uppercase tracking-[0.3em] text-amber-400 mb-6"
      >
        How it works
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-stone-50 mb-24"
      >
        Three steps. <span className="italic text-amber-400">Zero effort.</span>
      </motion.h2>

      <div className="space-y-24">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className={`grid grid-cols-1 md:grid-cols-12 gap-10 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
            data-testid={`step-${s.n}`}
          >
            <div className="md:col-span-6 [direction:ltr]">
              <div className="relative overflow-hidden rounded-2xl aspect-[16/10] clip-frame group">
                <img
                  src={s.src}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
            </div>
            <div className="md:col-span-6 [direction:ltr] md:px-8">
              <div className="flex items-center gap-5 mb-6">
                <span className="w-12 h-12 rounded-full border border-amber-400/50 flex items-center justify-center font-serif text-xl text-amber-400">
                  {s.n}
                </span>
                <span className="h-px flex-1 bg-gradient-to-r from-amber-400/40 to-transparent" />
              </div>
              <h3 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-stone-50 tracking-tight mb-4">{s.title}</h3>
              <p className="text-stone-400 text-base sm:text-lg leading-relaxed max-w-md">{s.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
